import { h, Component } from 'preact';
import { connect } from 'unistore/preact';
import BOC from '../bankOrCredit';
import CONSTANT, { CACHE } from '../../utils/constants';
import { API, PAYMODE } from '../../../../common/src/constant';
import { getEncodedQs, clientMessage } from '../../utils/common';

class PPB extends Component {
  boc;

  constructor(props) {
    super(props);
    const { url, query, method, data } = this.props.cache.getData(CACHE.API).requestPayload(API.PT);
    data.body = { ...query };
    const newStyle = `
    .ptm-card-input{
      border-color:${this.props.AppStyle.borderColor};
    }
    .ptm-card-input::placeholder{
      color:${this.props.AppStyle.bodyColor};
    }
      .ptm-card-input:focus{
        border-color:${this.props.AppStyle.themeBackgroundColor};
        caret-color:${this.props.AppStyle.themeBackgroundColor};
        color:${this.props.AppStyle.bodyColor};
      }
    `;
    const Locale = clientMessage(PAYMODE.PAYMENT_BANK.toLowerCase(), this.props.cache);
    this.state = {
      initializeObject: {
        type: 'INITIALIZE',
        paymode: {
          type: this.props.option.type,
          id: this.props.option.id
        },
        requestPayload: {
          targetURL: `${url}?${getEncodedQs(query)}`,
          queryParams: query,
          requestData: data,
          method
        },
        style: newStyle,
        messageObj: {
          label: Locale.label,
          error: Locale.error
        }
      }
    };
  }

  submit = () => {
    (typeof this.boc._component.submit === 'function' && this.boc._component.submit()) ||
      (typeof this.boc.submit === 'function' && this.boc.submit());
  };

  render({ option, isActive, onOptionSelect, offers, isPromoAvailable }, { initializeObject }) {
    return (
      <BOC
        {...{ option, isActive, onOptionSelect, offers, isPromoAvailable }}
        paymentMode={CONSTANT.PPBL}
        ref={r => (this.boc = r)}
        passcodeRequired
        {...{ initializeObject }}
      />
    );
  }
}
export default connect('AppStyle, cache')(PPB);



// WEBPACK FOOTER //
// ./components/ppb/index.js